import { render, staticRenderFns } from "./Aplicaciones.vue?vue&type=template&id=2f54e62d&scoped=true&lang=pug"
import script from "./Aplicaciones.vue?vue&type=script&lang=js"
export * from "./Aplicaciones.vue?vue&type=script&lang=js"
import style0 from "./Aplicaciones.vue?vue&type=style&index=0&id=2f54e62d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54e62d",
  null
  
)

export default component.exports